import { render, staticRenderFns } from "./newyearOrder.vue?vue&type=template&id=38003193&scoped=true&"
import script from "./newyearOrder.vue?vue&type=script&lang=js&"
export * from "./newyearOrder.vue?vue&type=script&lang=js&"
import style0 from "./newyearOrder.vue?vue&type=style&index=0&id=38003193&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38003193",
  null
  
)

export default component.exports